import ScreenReport from './ScreenReport'
import * as React from 'react'

function ManifestReport() {
  // wrapped container to split heirarchy and force re-render for state drop
  return <ScreenReport manifest={true} />
}

export default ManifestReport
